import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=e8098564&scoped=true"
import script from "./LinkButton.vue?vue&type=script&lang=ts"
export * from "./LinkButton.vue?vue&type=script&lang=ts"
import style0 from "./LinkButton.vue?vue&type=style&index=0&id=e8098564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8098564",
  null
  
)

export default component.exports